import { get } from 'lodash';
export function getEligibleList(inputs) {
    const { instrumentCheck, option, adjustments, defaultOut = [] } = inputs;
    // the adjustment list of the option has lower priority than the one in
    // instrument check. So if both instrument check and option object is
    // passed, this is the order to be followed while fetching the values.
    //
    // TODO: However, there's a subtle issue here. If a payment option that has
    // some offer fails to get any valid offers in instrument check, we will
    // end up showing the offer message (from option data) which is wrong. This
    // may be a very thin possibility, and can happen when offers get exhausted
    // between the time the options load and the time when user interacts with
    // the payment mode. This needs to be fixed better.
    const eligibleList = get(instrumentCheck, 'adjustments.adjustment_list') ||
        get(adjustments, 'adjustment_list') ||
        get(option, 'adjustments.adjustment_list') ||
        defaultOut;
    return eligibleList;
}
